module.exports = __webpack_public_path__ + "static/media/zenchef2.846a0a88.png";